<template lang="pug">
.safety-confirm-other-user-questions
  // questions content
  .mt-2.mb-1
    span.key-name 質問項目
  // questions
  .mb-3
    .questions.d-flex.flex-row.align-items-center.mb-3(v-for="item in _value")
      .question.flex-grow-1.pr-3
        .title {{ item.label }}
        .text {{ item.text }}
        .text(v-if="item.inputType == 0") 選択肢：{{ item.choicesLabel }}
        .text(v-else-if="item.inputType == 1") 自由記述
      .buttons.d-flex.flex-row-reverse.align-items-start
        UseSwitch(v-model="item.use")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { OtherUserSafetyConfirmMastersGetModel } from "@/commons/services/OtherUserSafetyConfirmMasters";
import UseSwitch from "@/mobile/basics/UseSwitch.vue";

/**
 * ### 新規送信メッセージ内容コンポーネント
 */
@Component({
  components: {
    UseSwitch
  }
})
export default class SafetyConfirmOtherUserQuestions extends Vue {
  @Prop({ required: true })
  value!: Array<UseId>;

  get _value(): Array<UseId> {
    return this.value;
  }

  set _value(newValue: Array<UseId>) {
    this.$emit("input", newValue);
    return;
  }
}

export interface UseId extends OtherUserSafetyConfirmMastersGetModel {
  /** 使用するかしないか */
  use: boolean;
  /** ラジオボタンの場合の選択肢 */
  choicesLabel: string;
}
</script>

<style lang="scss" scopeed>
.safety-confirm-other-user-questions {
  .questions {
    .title {
      font-weight: bold;
    }
    .text {
      font-size: 0.8rem;
    }
  }
}
</style>
